import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LighteningPopUpBackground, WalletIcon, WalletPopUpIcon } from '../../../../assets/icons';
import styles from './SetUpWalletModal.module.scss';
import { ApplicationRoutes } from '../../../../routes';

interface Props {
  onClose: () => void;
}

export const SetUpWalletModal: React.FC<Props> = ({ onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleTapToStart = () => {
    onClose();
    navigate(`/${ApplicationRoutes.CUSTOMER_WALLET}`);
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.container} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modal}>
          <LighteningPopUpBackground className={styles.bgPattern} />
          <div className={styles.iconWrap}>
            <WalletPopUpIcon />
          </div>
          <div className={styles.badge}>{t('common.labels.quickSetup')}</div>
          <h2 className={styles.title}>{t('home.setUpYourWallet')}</h2>
          <p className={styles.description}>
            {t('home.recieveYourOwnAccountNumber')}
          </p>
          <button className={styles.ctaButton} onClick={handleTapToStart}>
            {t('home.tapToStart')}
          </button>
        </div>
        <button className={styles.closeButton} onClick={onClose} aria-label={t('home.web.close')}>
          ✕
        </button>
      </div>
    </div>
  );
};
